import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { TipoDePropostaEnum } from "src/app/domain/enums/enums";
import { TipoSetorPropostaEnum } from "src/app/domain/enums/tipo-setor-proposta.enum";
import { ISelectProposal } from "src/app/domain/interfaces/proposal.interface";
import { ProposalService } from "src/app/domain/services/proposals.service";

@Component({
	selector: "app-tipo-setor-proposta",
	templateUrl: "./tipo-setor-proposta.component.html",
	styleUrls: ["./tipo-setor-proposta.component.css"]
})
export class TipoSetorPropostaComponent implements OnInit, OnDestroy {
	listTipoSetorProposta = [];
	validTipoSetorProposta = false;
	@Input() idPropostaTipo: number;
	@Input() idTipoSetorProposta: number = TipoSetorPropostaEnum.Publico;
	@Input() listTiposProposta = [];
	@Input() isSearch = false;
	@Input() componentInDialog = false;
	@Output() onDestroyComponent = new EventEmitter<boolean>();
	@Input() listaPropostasSetorPublico: ISelectProposal[] = [];
	@Input() listaPropostasSetorPrivado: ISelectProposal[] = [];
	@Output() onTipoPropostaChange = new EventEmitter<ISelectProposal>();

	private eventsSubscription: Subscription;
	@Input() events: Observable<ISelectProposal> = new Observable<ISelectProposal>();

	tipoSetorPropostaEnum = TipoSetorPropostaEnum;
	formGroup: UntypedFormGroup;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private router: Router,
		private propososalService: ProposalService
	) {}

	ngOnInit() {
		this.getTipoSetorProposta();
		if (this.componentInDialog) {
			this.formGroup = this.formBuilder.group({
				IdTipoSetorProposta: null,
				IdTipoProposta: [this.idPropostaTipo]
			});
		} else {
			this.formGroup = this.formBuilder.group({
				IdTipoSetorProposta: [this.idTipoSetorProposta],
				IdTipoProposta: [this.idPropostaTipo]
			});
		}

		this.eventsSubscription = this.events.subscribe(tipoProposta => {
			this.navigate(tipoProposta);
		});
	}

	radioProposalsTypeSelected(setor) {
		this.validTipoSetorProposta = true;
		this.idTipoSetorProposta = setor.value;
		this.formGroup.controls["IdTipoProposta"].reset();
		this.onTipoPropostaChange.emit(null);
	}

	selectTypeProposal(tipoProposta) {
		this.tipoPropostaChange(tipoProposta);

		if (!this.componentInDialog) this.navigate(tipoProposta);
	}

	navigate(tipoProposta) {
		switch (tipoProposta.value) {
			case TipoDePropostaEnum.Licitacoes:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrar"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum], setorProposta: TipoSetorPropostaEnum[this.idTipoSetorProposta]},
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.Contratos:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrar"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum], setorProposta: TipoSetorPropostaEnum[this.idTipoSetorProposta]},
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.Recursal:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrarSME"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum] },
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.SME:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrarSME"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum] },
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.Civel:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrarJudicial/civel"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum] },
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.Trabalhista:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrarJudicial/trabalhista"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum] },
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.Fiscal:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrarJudicial/fiscal"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum] },
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.Adiantamento:
				this.destroyComponent();
				this.router.navigate(["propostas-adiantamento/cadastrar"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum] },
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.LicitacoesPrivado:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrar"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum], setorProposta: TipoSetorPropostaEnum[this.idTipoSetorProposta]},
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.ContratosPrivado:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrar"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum], setorProposta: TipoSetorPropostaEnum[this.idTipoSetorProposta]},
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.ContratoConstrucao:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrar"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum], setorProposta: TipoSetorPropostaEnum[this.idTipoSetorProposta]},
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.ContratoFornecimento:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrar"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum], setorProposta: TipoSetorPropostaEnum[this.idTipoSetorProposta]},
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.ContratoPrestacaoServicos:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrar"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum], setorProposta: TipoSetorPropostaEnum[this.idTipoSetorProposta]},
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.ContratoPrivadoConstrucao:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrar"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum], setorProposta: TipoSetorPropostaEnum[this.idTipoSetorProposta]},
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.ContratoPrivadoFornecimento:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrar"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum], setorProposta: TipoSetorPropostaEnum[this.idTipoSetorProposta]},
					state: { bypassFormGuard: true }
				});
				break;

			case TipoDePropostaEnum.ContratoPrivadoPrestacaoServicos:
				this.destroyComponent();
				this.router.navigate(["propostas/cadastrar"], {
					queryParams: { listType: TipoDePropostaEnum[tipoProposta.value as keyof typeof TipoDePropostaEnum], setorProposta: TipoSetorPropostaEnum[this.idTipoSetorProposta]},
					state: { bypassFormGuard: true }
				});
				break;
		}
	}

	destroyComponent() {
		this.onDestroyComponent.emit(true);
	}

	getTipoSetorProposta() {
		this.propososalService.getTipoSetorProposta().subscribe(res => {
			this.listTipoSetorProposta = res.result;
			if (this.isSearch) {
				const idSetorPublico = 1;
				const idSetorPrivado = 2;
				if (this.listaPropostasSetorPublico.length <= 0) {
					this.listTipoSetorProposta = this.listTipoSetorProposta.filter(set => set.id != idSetorPublico);
				}

				if (this.listaPropostasSetorPrivado.length <= 0) {
					this.listTipoSetorProposta = this.listTipoSetorProposta.filter(set => set.id != idSetorPrivado);
				}
			}
		});
	}

	tipoPropostaChange(tipoProposta: ISelectProposal) {
		this.onTipoPropostaChange.emit(tipoProposta);
	}

	ngOnDestroy(): void {
		this.eventsSubscription.unsubscribe();
	}
}
